<template>
<div class="forget-wrapper">
    <div class="forget">
        <title-bar title="忘记密码" type="close"></title-bar>
        <div class="main" v-if="!success">
            <div class="logo">
                <img src="../../assets/imgs/logo_avator.png" />
            </div>
            <mt-field class="email"  placeholder="邮箱" type="email" v-model="email">
                <img src="../../assets/imgs/email_icon.png" />
            </mt-field>
            <mt-button class="login_btn" type="primary" @click="sendEmail">确定</mt-button>
        </div>
        <div class="success_tip" v-else>
            已发送邮件到邮箱 {{email}} <br/>
            请前往邮箱重置密码后再登录
        </div>
    </div>
</div>
</template>

<script>
import titleBar from "@/components/layout/TitleBar"

export default {
    name: "forget",
    data() {
        return {
            email: "",
            success: false
        }
    },
    methods: {
        async sendEmail() {
            let email = this.email.trim();
            if(this.checkEmail(email)){
                let res = await API.account.retrievePassword(email);
                let data = res.data;
                if(data.code == '00000'){
                    this.success = true
                }
            }

            MtaH5.clickStat("forget_password");
        },
        checkEmail(email){
            let reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
            if(!email){
                this.$root.eventBus.$emit('showTip','输入不能为空哦','failed')
                return false
            }else if(!reg.test(email)){
                this.$root.eventBus.$emit('showTip','这好像不是一个邮箱','failed')
                return false
            }else{
                return true;
            }
        },
    },
    components: {
        titleBar
    }
}
</script>

<style lang="scss" scoped>
.forget-wrapper{
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    height:100%;
    .forget {
        width: 17.5rem;
        height: 100%;
        margin: 0 auto;
        .logo {
            width: 4rem;
            margin: 4.63rem auto 2.5rem auto;
            padding-top: constant(safe-area-inset-top);
            padding-top: env(safe-area-inset-top);
            img {
                width: 100%;
            }
        }
        .success_tip {
            width: 100%;
            font-size: 0.75rem;
            text-align: center;
            color: #888888;
            position: absolute;
            left: 0;
            top: 40%;
            line-height: 2;
        }
    }
}

</style>